import { inject, Injectable, Service } from '@angular/core';
import { BasicHttpClientService } from 'app/shared/services/basic-http-client.service';
import { environment } from 'environments/environment';
import { ShopContextStore } from 'app/shared/state/shop-context.store';
import { PagedResponse } from '../models/paged-response.model';
import { SeasonsReferenceDTO } from '../models/seasons-reference.model';
import { ValidityDateType } from 'app/back-office/shared/enum/season-reference.enum';

@Service()
export class SeasonsReferenceService {
  private readonly baseUrl: string = environment.urls.apiUrl.url;
  private readonly _shopContext = inject(ShopContextStore);

  private readonly _httpClient = inject(BasicHttpClientService);

  getList(loaderId: string, skipCount: number, maxResultCount: number, searchString: string, validityDateType: ValidityDateType, sorting?: string){
    const storeId = this._shopContext.currentShop().id;
    const params = {
      searchString: searchString ?? '',
      storeId,
      maxResultCount,
      sorting,
      validityDateType,
      skipCount
    };
    return this._httpClient.get<PagedResponse<SeasonsReferenceDTO>>(`${this.baseUrl}/season-references`, { params }, loaderId);
  }

  deleteSeasonReference(id: number, loaderId: string){
    return this._httpClient.delete(`${this.baseUrl}/season-references/${id}`, {} , loaderId);
  }

  createNewSeasonReference(sr: SeasonsReferenceDTO, loaderId: string){
    sr.storeId = this._shopContext.currentShop().id;
    return this._httpClient.post(`${this.baseUrl}/season-references/`, sr , {} , loaderId)
  }

  editSeasonReference(sr: SeasonsReferenceDTO, loaderId: string){
    sr.storeId = this._shopContext.currentShop().id;
    return this._httpClient.put(`${this.baseUrl}/season-references/${sr.id}`, sr , {} , loaderId)
  }

  getSeasonReference(id: number, loaderId: string){
    return this._httpClient.get<SeasonsReferenceDTO>(`${this.baseUrl}/season-references/${id}`, {} , loaderId);
  }
}
